(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vantra-assurance"] && !Shopify.designMode) return;
  try {
    class VantraEta extends HTMLElement {
    connectedCallback() {
      const min = parseInt(this.dataset.min, 10);
      const max = parseInt(this.dataset.max, 10);
      if (!min || !max || max < min) return;
      const fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      const from = this.addBusinessDays(new Date(), min);
      const to = this.addBusinessDays(new Date(), max);
      this.innerHTML = '';
      this.append('Order today, arrives ');
      const a = document.createElement('strong'); a.textContent = fmt.format(from);
      const b = document.createElement('strong'); b.textContent = fmt.format(to);
      this.append(a, ' to ', b);
    }

    addBusinessDays(date, days) {
      const d = new Date(date);
      let left = days;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 0 && day !== 6) left -= 1;
      }
      return d;
    }
  }
  if (!customElements.get('vantra-eta')) customElements.define('vantra-eta', VantraEta);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vantra-offer-box"] && !Shopify.designMode) return;
  try {
    class VantraOfferBox extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.vob__row'));
      this.addEventListener('change', (e) => {
        if (e.target && e.target.classList.contains('vob__radio')) this.select(e.target);
      });
      const checked = this.querySelector('.vob__radio:checked');
      if (checked) this.select(checked);
      if (this.hasAttribute('data-hide-quantity')) this.hideNativeQuantity();
    }

    select(radio) {
      this.cards.forEach((card) => card.classList.toggle('is-selected', card.contains(radio)));
      this.paintDetail(radio);
      this.writeQuantity(parseInt(radio.value, 10) || 1);
      if (this.hasAttribute('data-sync-button')) this.syncButton(radio.dataset.total);
    }

    paintDetail(radio) {
      const d = radio.dataset;
      const discounted = Boolean(d.pct) && d.pct !== '0';
      const set = (sel, value) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = value || '';
      };
      const was = this.querySelector('[data-panel-was]');
      if (was) {
        was.hidden = !discounted;
        was.textContent = discounted ? d.was : '';
      }
      set('[data-panel-now]', d.total);
      const pct = this.querySelector('[data-panel-pct]');
      if (pct) {
        pct.hidden = !discounted;
        pct.textContent = discounted ? `Save ${d.save} · ${d.pct}% off` : '';
      }
      set('[data-panel-sub]', d.sub);
    }

    form() {
      return this.closest('form[action*="/cart/add"]') ||
             document.querySelector('form[action*="/cart/add"]');
    }

    hideNativeQuantity() {
      // This block is the quantity control, so a second stepper only lets the
      // customer land on a quantity that matches no tier.
      const form = this.form();
      if (!form) return;
      const input = form.querySelector('input[name="quantity"]');
      if (!input) return;
      // Hide the outermost wrapper. Hiding only the inner stepper left an empty flex
      // item in the button row, and the row gap pushed the button 11px off the column.
      const wrapper = input.closest('.quantity-selector-wrapper') ||
        input.closest('.quantity-selector, quantity-selector-component') || input.parentElement;
      if (wrapper) wrapper.style.display = 'none';
    }

    syncButton(total) {
      const form = this.form();
      if (!form || !total) return;
      const btn = form.querySelector('[type="submit"], button[name="add"]');
      // A disabled button is showing its own state, such as Unavailable. Leave it alone.
      if (!btn || btn.disabled) return;
      let tag = btn.querySelector('[data-vob-price]');
      if (!tag) {
        tag = document.createElement('span');
        tag.setAttribute('data-vob-price', '');
        btn.appendChild(tag);
      }
      tag.textContent = ` · ${total}`;
    }

    writeQuantity(qty) {
      const form = this.form();
      if (!form) return;
      const visible = form.querySelector('input[name="quantity"]');
      if (visible) {
        visible.value = qty;
        visible.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      let hidden = form.querySelector('input[name="quantity"][data-vob]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'quantity';
        hidden.setAttribute('data-vob', '');
        form.appendChild(hidden);
      }
      hidden.value = qty;
    }
  }

  if (!customElements.get('vantra-offer-box')) {
    customElements.define('vantra-offer-box', VantraOfferBox);
  }
  } catch(e) { console.error(e); }
})();

})();
